import { useState } from 'react'

import { isTvTickerPostType } from '../../../Newsboard.utils'
import { NewsboardPostAutomate } from '../NewsboardPostAutomate'
import { NewsboardPostComments } from '../NewsboardPostComments'
import { NewsboardPostLike } from '../NewsboardPostLike'
import {
  NewsboardPostReport,
  NewsboardPostReportsTableModal,
} from '../NewsboardPostReport'
import { NewsboardPostViews } from '../NewsboardPostViews'

function NewsboardPostTypeFooter({ data }) {
  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    setModal(null)
  }

  function handleOpenReport(tab) {
    setModal(
      <NewsboardPostReportsTableModal
        entityId={data.uuid}
        initialTab={tab}
        onClose={handleCloseModal}
      />
    )
  }

  return (
    <>
      {!isTvTickerPostType(data) ? (
        <>
          <NewsboardPostLike data={data} onOpenReport={handleOpenReport} />
          {!data.isProfile ? <NewsboardPostComments data={data} /> : null}
        </>
      ) : null}

      {data?.permissions.can_view_viewers ? (
        <NewsboardPostViews data={data} onOpenReport={handleOpenReport} />
      ) : null}
      {data?.permissions.can_view_post_report ? (
        <NewsboardPostReport data={data} onOpenReport={handleOpenReport} />
      ) : null}
      {data?.automation_id ? (
        <NewsboardPostAutomate onOpenReport={handleOpenReport} />
      ) : null}
      {modal}
    </>
  )
}

export default NewsboardPostTypeFooter
